import {
  ChangeDetectionStrategy,
  Component,
  effect,
  EventEmitter,
  input,
  model,
  Output,
} from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { ITab } from "./tab.model";
import { NgClass, NgComponentOutlet, NgFor } from "@angular/common";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  selector: "er-tabs",
  imports: [MatTabsModule, NgFor, NgComponentOutlet, NgClass, TranslocoPipe],
  standalone: true,
  templateUrl: "./tabs.component.html",
  styleUrl: "./tabs.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent {
  public readonly tabs = input.required<ITab[]>({ alias: "tabs" });
  public readonly selectedTab = input<string | null>();

  public readonly selectedIndex = model(0, { alias: "selectedIndex" });

  @Output() onTabChange: EventEmitter<string> = new EventEmitter();

  constructor() {
    effect(() => {
      const selected = this.selectedTab();
      if (selected) {
        const index = this.tabs().findIndex((tab) => tab.name === selected);
        if (index !== -1) {
          this.selectedIndex.set(index);
        }
      }
    });
  }

  public selectedIndexChange(index: number) {
    this.selectedIndex.set(index);
    this.onTabChange.emit(this.tabs()[index].name);
  }
}
